/**
 * WhatsApp wa.me URL helpers.
 */

export function toWaMeNumber(raw: string, defaultCountryCode = '39'): string {
  if (!raw) return '';
  let s = raw.trim().replace(/[^\d+]/g, '');
  s = s.replace(/^00/, '+');

  if (s.startsWith('+')) s = s.slice(1); // wa.me wants digits-only

  if (!s.startsWith(defaultCountryCode) && s.length > 0 && s.length <= 10) {
    s = defaultCountryCode + s;
  }

  return s;
}

export function buildWaMeUrl(phoneRaw: string, message: string): string {
  const phone = toWaMeNumber(phoneRaw);
  const text = encodeURIComponent(message ?? '');
  return `https://wa.me/${phone}?text=${text}`;
}
